import PropTypes from 'prop-types';
import React, {useMemo, useState} from 'react';
import {DatePicker} from '@mui/x-date-pickers-pro';
import {Stack, Typography} from '@mui/material';

const DATE_ISO_FORMAT = 'yyyy-MM-dd';

const DateRangePicker = ({
  endDate,
  maxDate,
  minDate,
  onChangeEndDate,
  onChangeStartDate,
  startDate,
}) => {
  const [startDateError, setStartDateError] = useState();
  const [endDateError, setEndDateError] = useState();

  const startDateErrorMessage = useMemo(() => {
    switch (startDateError) {
      case 'maxDate':
        return 'Start date must be before or equal to end date';
      case 'minDate':
        return 'Start date must be after or equal to minimum start date';
      case 'invalidDate':
        return 'Your date is not valid';
      default:
        return '';
    }
  }, [startDateError]);

  const endDateErrorMessage = useMemo(() => {
    switch (endDateError) {
      case 'maxDate':
        return 'End date must be before or equal to maximum end date';
      case 'minDate':
        return 'End date must be after or equal to start date';
      case 'invalidDate':
        return 'Your date is not valid';
      default:
        return '';
    }
  }, [endDateError]);

  return (
    <Stack direction="row" sx={{gap: 1, alignItems: 'start', flex: 1}}>
      <DatePicker
        format={DATE_ISO_FORMAT}
        label="Start"
        maxDate={endDate?.endOf('day') ?? maxDate}
        minDate={minDate}
        onChange={date => onChangeStartDate(date ? date.startOf('day') : null)}
        onError={newError => setStartDateError(newError)}
        slotProps={{
          field: {
            clearable: true,
          },
          textField: {
            helperText: startDateErrorMessage,
            required: true,
            size: 'small',
          },
        }}
        sx={{flex: 1}}
        timezone="utc"
        value={startDate}
      />

      <Typography sx={{paddingBlockStart: 1}}> – </Typography>

      <DatePicker
        format={DATE_ISO_FORMAT}
        label="End"
        maxDate={maxDate}
        minDate={startDate?.startOf('day') ?? minDate}
        onChange={date => onChangeEndDate(date ? date.endOf('day') : null)}
        onError={newError => setEndDateError(newError)}
        slotProps={{
          field: {
            clearable: true,
          },
          textField: {
            helperText: endDateErrorMessage,
            size: 'small',
          },
        }}
        sx={{flex: 1}}
        timezone="utc"
        value={endDate}
      />
    </Stack>
  );
};

DateRangePicker.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  onChangeStartDate: PropTypes.func,
  onChangeEndDate: PropTypes.func,
};

export default DateRangePicker;
